import { render } from "./Document.vue?vue&type=template&id=0a7d65e3&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import "./Document.vue?vue&type=style&index=0&id=0a7d65e3&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7d65e3"]])

export default __exports__